export class SdkError extends Error {
    code;
    cause;
    constructor(code, message, cause) {
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = "SdkError";
    }
}
export const usage = (message) => new SdkError("USAGE", message);
export const unsupported = (message) => new SdkError("UNSUPPORTED", message);
export const unavailable = (message, cause) => new SdkError("UNAVAILABLE", message, cause);
export const internal = (message, cause) => new SdkError("INTERNAL", message, cause);
export const notFound = (message) => new SdkError("NOT_FOUND", message);
